import * as React from "react";
import { Send, Paperclip } from "lucide-react"; // Import Paperclip icon
import { Avatar, AvatarFallback, AvatarImage } from "../../../shadcn/components/ui/Avatar";
import { Button } from "../../../shadcn/components/ui/Button";
import { Input } from "../../../shadcn/components/ui/Input";
import { ScrollArea } from "../../../shadcn/components/ui/ScrollArea";
import { Card, CardContent, CardHeader, CardTitle } from "../../../shadcn/components/ui/Card";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import Pusher from "pusher-js";
import { Dialog, DialogTrigger, DialogContent, DialogTitle, DialogDescription } from "../../../shadcn/components/ui/Dialog";
import { MessageCircle } from "lucide-react";
import UserGroupChat from "../../serviceProvider dashboard/IndustryRelations/UserPublicgroup";

export function CorporateMessages() {
  const [newMessage, setNewMessage] = useState("");
  const [data, setData] = useState({ groups: [] });
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [messages, setMessages] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null); // State for the selected file
  const currentUserEmail = localStorage.getItem("email");
  const [imagePreview, setImagePreview] = useState(null); // State for image preview


  const messagesEndRef = useRef(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [open, setOpen] = useState(false);

  // Function to fetch user details
  const handleClick = async (username) => {
    console.log("user click");
    try {
      const response = await axios.get(
        `https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/get-userdata-email?email=${username}`
      );
      if (response.data ) {

        setSelectedUser(response.data);
      
        setOpen(true); // Open modal
      }
      console.log(selectedUser)
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    const fetchGroups = async () => {
      const token = localStorage.getItem("authToken");
      try {
        const response = await axios.post(
          "https://silver-tlc-backend-delta.vercel.app/api/v1/message/usergroup",
          { token }
        );
        setData(response.data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchGroups();
  }, []);

  const handleGroupClick = (groupName) => {
    fetchMessages(groupName);
  };

  const fetchMessages = async (groupName) => {
    setLoading(true);
    const token = localStorage.getItem("authToken");
    try {
      const response = await axios.post(
        "https://silver-tlc-backend-delta.vercel.app/api/v1/message/chatroom/get-message",
        { groupName, token }
      );
      setMessages(response.data.groupMessages || []);
      console.log("Image URL:", messages.imageMessage); // Check the image URL being returned

      console.log(messages)
      setSelectedGroup(groupName);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };



  const handleFileChange = (e) => {
    const files = e.target.files; // Get all selected files
    if (!files || files.length === 0) {
      console.error("No files selected.");
      setImagePreview([]); // Clear preview if no file is selected
      return;
    }

    const fileArray = Array.from(files); // Convert FileList to array
    setSelectedFile(fileArray); // Store the files in the state

    console.log(fileArray[0]); // Log first file from the array directly

    // Create preview URLs for each file
    const previewUrls = fileArray.map(file => URL.createObjectURL(file));
    setImagePreview(previewUrls); // Store all preview URLs in the state
};

const handlesClick = async (groupName,userEmail) => {
  const currentUser = currentUserEmail; // Your logged-in user
  const token = localStorage.getItem("authToken");

  try {
    // Check if a chatroom already exists
    const checkResponse = await axios.post(
      "https://silver-tlc-backend-delta.vercel.app/api/v1/message/chatroom/get-message",
      { groupName: ` ${groupName}`, token }
    );

    if (checkResponse.data.groupMessages) {
      // Group exists, open it
      setSelectedGroup(` ${groupName}`);
      setMessages(checkResponse.data.groupMessages);
      return;
    }

    // If no group exists, create a new one
    const createResponse = await axios.post(
      "https://silver-tlc-backend-delta.vercel.app/api/v1/message/chatroom/create",
      {
        members: [currentUser, userEmail],
        groupName: ` ${groupName}`,
        token,
      }
    );

    if (createResponse.data.chatRoom) {
      setSelectedGroup(createResponse.data.chatRoom.groupName);
      fetchMessages(createResponse.data.chatRoom.groupName);
    }
  } catch (error) {
    console.error("Error handling chat room:", error);
  }
};
  
const handleSendMessage = async () => {
  if (newMessage.trim() === "" && !selectedFile) return;

  const stringifiedToken  = localStorage.getItem("authToken");

  // Convert to string (if it's not already a string)
  const token = JSON.stringify(stringifiedToken );
  if (!token) {
    console.error("No auth token found in localStorage");
    return;
  }

  const formData = new FormData();
  formData.append("token", token);
  formData.append("textMessage", newMessage);
  formData.append("groupName", selectedGroup);

  if (selectedFile) {
    formData.append("imageMessage", selectedFile[0]); // Append the file
   
  }



  

  try {

    console.log(formData)
    const response = await axios.post(
      "https://silver-tlc-backend-delta.vercel.app/api/v1/message/chatroom/sendmessage",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    // Clear input and preview after sending
    setNewMessage("");
    setSelectedFile(null);
    setImagePreview(null);
  } catch (error) {
    console.error("Error sending message:", error);
    setError(error);
  }
};
  useEffect(() => {
    if (selectedGroup) {
      const pusher = new Pusher("e9cffd90dff19b3b8976", {
        cluster: "ap2",
      });
  
      const sanitizedGroupName = selectedGroup.replace(/ /g, "");
      const channel = pusher.subscribe(sanitizedGroupName);
  
      channel.bind("send-message", (data) => {
        // Assuming the structure is like { message: { textMessage, sender, date, imageMessage }}
        const { message } = data;  // Destructure the message object
    
        console.log("Received Data from Pusher:", message);
    
        if (!message || !message.textMessage || !message.sender || !message.date) {
          console.error("Received message is missing required fields");
          return;
        }
    
        // Update state with new message
        setMessages((prevMessages) => [
          ...prevMessages,
          {
            textMessage: message.textMessage,
            sender: message.sender,
            date: message.date,
            imageMessage: message.imageMessage || null, // Ensure image URL is updated, if any
          },
        ]);
      
      });
  
      return () => {
        channel.unbind_all();
        channel.unsubscribe();
      };
    }
  }, [selectedGroup]);

  const handleUserClick = async (userEmail) => {
    const currentUser = currentUserEmail; // Your logged-in user
    const token = localStorage.getItem("authToken");

    try {
        // Check if a chatroom already exists
        const checkResponse = await axios.post(
            "https://silver-tlc-backend-delta.vercel.app/api/v1/message/chatroom/get-message",
            { groupName: `Chat with ${userEmail}`, token }
        );

        if (checkResponse.data.groupMessages) {
            // Group exists, open it
            setSelectedGroup(`Chat with ${userEmail}`);
            setMessages(checkResponse.data.groupMessages);
            return;
        }

        // If no group exists, create a new one
        const createResponse = await axios.post(
            "https://silver-tlc-backend-delta.vercel.app/api/v1/message/chatroom/create",
            {
                members: [currentUser, userEmail],
                groupName: `Chat with ${userEmail}`,
                token,
            }
        );

        if (createResponse.data.chatRoom) {
            setSelectedGroup(createResponse.data.chatRoom.groupName);
            fetchMessages(createResponse.data.chatRoom.groupName);
        }
    } catch (error) {
        console.error("Error handling chat room:", error);
    }
};


  return (
    <div className="container mx-auto p-4">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Left Column */}
        <div className="space-y-6">
          {/* Messages Section */}
          <Card>
            <CardHeader>
              <CardTitle className="flex gap-2">
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.75 11.25H21.25M8.75 16.25H21.25M26.25 25L22.0946 22.9222C21.7796 22.7647 21.6221 22.686 21.457 22.6305C21.3105 22.5812 21.1596 22.5456 21.0065 22.5241C20.834 22.5 20.6579 22.5 20.3058 22.5H7.75C6.34986 22.5 5.6498 22.5 5.11503 22.2275C4.64461 21.9879 4.26216 21.6054 4.02249 21.135C3.75 20.6002 3.75 19.9001 3.75 18.5V9C3.75 7.59986 3.75 6.8998 4.02249 6.36502C4.26216 5.89461 4.64461 5.51216 5.11503 5.27249C5.6498 5 6.34987 5 7.75 5H22.25C23.6501 5 24.3503 5 24.885 5.27249C25.3554 5.51216 25.7379 5.89461 25.9775 6.36502C26.25 6.8998 26.25 7.59987 26.25 9V25Z"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Messages
              </CardTitle>
            </CardHeader>
            <CardContent>
            <div className="space-y-4 max-h-40 overflow-auto no-scrollbar">
            {data.groups
                  .filter((group) => group.members.length ===2)
                  .map((group) => (
                    <div
                      key={group.id}
                      onClick={() => handleGroupClick(group.groupName)}
                      className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 cursor-pointer"
                    >
                      <Avatar>
                        <AvatarImage src={group.avatar} alt={group.groupName} />
                        <AvatarFallback>{group.groupName[0]}</AvatarFallback>
                      </Avatar>
                      <div className="flex-1">
                        <h3 className="font-medium">{group.groupName}</h3>
                      </div>
                    </div>
                  ))}
</div>
            </CardContent>
          </Card>

          {/* Chat Rooms Section */}
          <Card>
            <CardHeader>
              <CardTitle className="flex gap-2">
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.75 11.25H21.25M8.75 16.25H21.25M26.25 25L22.0946 22.9222C21.7796 22.7647 21.6221 22.686 21.457 22.6305C21.3105 22.5812 21.1596 22.5456 21.0065 22.5241C20.834 22.5 20.6579 22.5 20.3058 22.5H7.75C6.34986 22.5 5.6498 22.5 5.11503 22.2275C4.64461 21.9879 4.26216 21.6054 4.02249 21.135C3.75 20.6002 3.75 19.9001 3.75 18.5V9C3.75 7.59986 3.75 6.8998 4.02249 6.36502C4.26216 5.89461 4.64461 5.51216 5.11503 5.27249C5.6498 5 6.34987 5 7.75 5H22.25C23.6501 5 24.3503 5 24.885 5.27249C25.3554 5.51216 25.7379 5.89461 25.9775 6.36502C26.25 6.8998 26.25 7.59987 26.25 9V25Z"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Chat Rooms
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-4 max-h-40 overflow-auto no-scrollbar">
                {data.groups
                  .filter((group) => group.members.length > 2)
                  .map((group) => (
                    <div
                      key={group.id}
                      onClick={() => handleGroupClick(group.groupName)}
                      className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 cursor-pointer"
                    >
                      <Avatar>
                        <AvatarImage src={group.avatar} alt={group.groupName} />
                        <AvatarFallback>{group.groupName[0]}</AvatarFallback>
                      </Avatar>
                      <div className="flex-1">
                        <h3 className="font-medium">{group.groupName}</h3>
                      </div>
                    </div>
                  ))}
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Right Column - Live Chat */}
        <Card>
          <CardHeader>
            <CardTitle className="flex gap-2">
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.75 11.25H21.25M8.75 16.25H21.25M26.25 25L22.0946 22.9222C21.7796 22.7647 21.6221 22.686 21.457 22.6305C21.3105 22.5812 21.1596 22.5456 21.0065 22.5241C20.834 22.5 20.6579 22.5 20.3058 22.5H7.75C6.34986 22.5 5.6498 22.5 5.11503 22.2275C4.64461 21.9879 4.26216 21.6054 4.02249 21.135C3.75 20.6002 3.75 19.9001 3.75 18.5V9C3.75 7.59986 3.75 6.8998 4.02249 6.36502C4.26216 5.89461 4.64461 5.51216 5.11503 5.27249C5.6498 5 6.34987 5 7.75 5H22.25C23.6501 5 24.3503 5 24.885 5.27249C25.3554 5.51216 25.7379 5.89461 25.9775 6.36502C26.25 6.8998 26.25 7.59987 26.25 9V25Z"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Live Chat
            </CardTitle>
          </CardHeader>
          <CardContent className="flex flex-col">
            {/* Messages Area */}
            <div className="flex-1 max-h-80 overflow-y-auto no-scrollbar space-y-4 pb-6">
              {selectedGroup &&
                messages.map((message) => (
                  <div
                    key={message._id || message.date}
                    className={`flex items-start cursor-pointer gap-3 p-3 ${
                      message.sender === currentUserEmail ? "justify-end" : "justify-start"
                    }`}
                  >
                    <Dialog>
                      <DialogTrigger>
                        <Avatar onClick={() => handleClick(message.sender)}>
                          <AvatarFallback>
                            {message.sender ? message.sender.charAt(0).toUpperCase() : "U"}
                          </AvatarFallback>
                        </Avatar>
                      </DialogTrigger>
                      <DialogContent style={{ backgroundColor: '#ffffff', padding: '24px', borderRadius: '8px' }}>
  <DialogTitle style={{ fontSize: '24px', fontWeight: 'bold', color: '#000000', textAlign: 'center', marginBottom: '16px' }}>
    User Details
  </DialogTitle>
  <DialogDescription style={{ color: '#000000' }}>
    {selectedUser && (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
        {/* Avatar */}
        <div
          style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: '#3f51b5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#ffffff',
            fontSize: '24px',
            fontWeight: 'bold',
          }}
        >
          {selectedUser.usersData.name.charAt(0)}
        </div>

        {/* User Details */}
        <div style={{ textAlign: 'center' }}>
          <p style={{ margin: '8px 0', fontSize: '18px', fontWeight: '500' }}>
            <strong>Name:</strong> {selectedUser.usersData.name} <Button 
          onClick={() => handlesClick(selectedUser.usersData.name, selectedUser.usersData.email)}
          style={{ 
            marginLeft: '8px', 
            backgroundColor: 'transparent', 
            border: 'none', 
            cursor: 'pointer', 
            color: '#3f51b5' 
          }}
        >
          <MessageCircle style={{ fontSize: '20px' }} /> {/* Replace with your chat icon */}
        </Button>
          </p>
          <p style={{ margin: '8px 0', fontSize: '16px' }}>
            <strong>Email:</strong> {selectedUser.usersData.email}
          </p>
          <p style={{ margin: '8px 0', fontSize: '16px' }}>
            <strong>Phone:</strong> {selectedUser.usersData.phonenumber}
          </p>
          <p style={{ margin: '8px 0', fontSize: '16px' }}>
            <strong>Role:</strong> {selectedUser.usersData.role}
          </p>
        </div>
      </div>
    )}
  </DialogDescription>
</DialogContent>
                    </Dialog>
                    <div className="flex-1 max-w-xs">
                      <div
                        className={`p-3 rounded-lg ${
                          message.sender === currentUserEmail
                            ? "bg-purple-700 text-white ml-auto"
                            : "bg-gray-200 text-gray-800 mr-auto"
                        }`}
                      >
                        <h3 className="font-medium text-sm">
                          {message.sender === currentUserEmail ? "You" : message.sender}
                        </h3>
                        {message.textMessage && <p className="text-sm">{message.textMessage}</p>}
                        {message.imageMessage &&
                          Array.isArray(message.imageMessage) &&
                          message.imageMessage.map((imgUrl, index) => (
                            <img
                              key={index}
                              src={imgUrl}
                              alt={`Uploaded ${index + 1}`}
                              className="mt-2 rounded-lg max-w-full h-auto"
                            />
                          ))}
                        <span className="text-xs text-gray-400">
                          {new Date(message.date).toLocaleString()}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              <div ref={messagesEndRef} />
            </div>

            {/* Input Area */}
            <div className="mt-4 flex flex-col gap-3 pt-4 border-t border-gray-300">
  {/* Image Preview */}
  {imagePreview && (
  <div className="relative">
    {imagePreview.map((preview, index) => (
      <div key={index} className="relative">
        <img
          src={preview}
          alt="Preview"
          className="w-24 h-24 object-cover rounded-lg"
        />
        <button
          onClick={() => {
            setImagePreview(null);
            setSelectedFile(null);
          }}
          className="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    ))}
  </div>
)}



  {/* Input Area */}
  <div className="flex gap-3">
    {/* Attachment Button */}
    <label htmlFor="file-input" className="cursor-pointer">
      <Paperclip className="text-gray-500 hover:text-gray-700" />
    </label>
    <input
      id="file-input"
      type="file"
      onChange={handleFileChange}
      className="hidden"
    />
    <Input
      value={newMessage}
      onChange={(e) => setNewMessage(e.target.value)}
      placeholder="Type a message"
      className="flex-1"
    />
    <Button onClick={handleSendMessage} disabled={!newMessage.trim() && !selectedFile}>
      <Send />
    </Button>
  </div>
</div>
          </CardContent>


        </Card>
      </div>
      <UserGroupChat className="pt-6"/>
    </div>
  );
}